const INFO = {

	main: {
		title: "TCagency.org - IT Services",
		name: "TCAgency Sales & Marketing",
		email: "sales@tcagency.org",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/",
		linkedin: "https://linkedin.com/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
		odoo: "https://www.odoo.com/",
	},

	homepageswiper: [
		{
			title: "The All-in-One ERP Solution for Your Business",
			image: "homepage.jpg",
			imageflag: true,
			description:
				"We specialize in designing tailored ERP solutions with Odoo and IT services to help businesses boost productivity, drive growth, and increase ROI. Our solutions streamline core functions such as accounting, sales, project management, CRM, human resources, cloud services, monitoring, and daily operations—empowering your business to operate more efficiently and smoother, data-driven decisions.",
		},
		{
			title: "Maximize Your Business Growth with Grant-Supported IT Solutions",
			image: "15-Government-Grants-removebg-preview.png",
			imageflag: true,
			description:
				"Get up to %% funding for eligible IT solutions like ERP, cloud, and digital transformation. We work closely with government grant advisors to help SMEs apply easily and successfully — grant evaluation included.",
		},
	],

	about: {
		title: "Empowering Your Business Through Tech & Talent",
		description: "",	// refer to page about.jsx
	},

	contact: {
		title: "Let's Get in Touch: Ways to Connect with us",
		description: "",	// refer to page contact.jsx
	},

	articles: {
		title: "Use Cases - Stories",
		description:
			"Your success is our success. That is why we aim to deliver only the best customer experience, solutions and services. We are proud to have worked with some of the most innovative companies in the world, and we are excited to share their stories with you.",
	},

	serviceERP: {
		title: "For SMALL & MEDIUM businesses and Enterprises",
		description:
			"We provide end-to-end Odoo ERP services tailored to businesses of all sizes, especially SMEs and startups — from initial implementation and module configuration to custom development, system integration, and data migration. Our team specializes in deploying Odoo on secure cloud infrastructure and offers continuous support, training, and maintenance to ensure optimal performance. We also design and automate workflows, and deliver insightful reporting solutions to help businesses streamline operations and scale efficiently. Whether you're using the Odoo Community or Odoo Enterprise edition, we offer flexible, cost-effective solutions that evolve with your business.",
	},

	serviceBI: {
		title: "Empower Smarter Decisions with Cutting-Edge BI Solutions",
		description: "We deliver modern, open-source Business Intelligence (BI) solutions to businesses across Singapore and Malaysia. Our team specializes in the deployment, consulting, and training of BI tools — helping organizations visualize, explore, and unlock the full potential of their data with speed and flexibility.", 	// refer to page servicesIT.jsx
	},

	serviceIT: {
		title: "IT Services & Cloud Solutions",
		description: "", 	// refer to page servicesIT.jsx
	},

	serviceRecruit: {
		title: "Recruitment Support Services - Offline",
		description: "", 	// refer to page servicesRecruitment.jsx
	},

	services: [
		{
			title: "Government Grant Support",
			description:
				"Our IT services — such as ERP implementation, cloud solutions, and digital transformation are eligible for various Singapore government grants that help SMEs save costs. We work closely with  grant advisors from SME Centre to guide you through the application process and evaluate which grants you qualify for, making it easy and hassle-free.",
			logo: "../grant1.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: false,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Human Resources Management",
			description:
				"Our Human Resources solution streamlines your entire HR workflow—covering recruitment, referrals, onboarding, attendance, time off, payroll, appraisals, and more. It reduces administrative workload, boosts efficiency, and scales seamlessly with your team as your business grows.",
			logo: "../human-resources.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Sales & Project Management",
			description:
				"Sales Management brings together CRM, Sales, Subscriptions, and Project Management, along with Timesheets, Helpdesk, and Planning—all in one powerful platform. Streamline your sales process, manage leads, track project progress, and drive performance with real-time insights and reminders.",
			logo: "../kpi-evaluation.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Website & E-commerce",
			description:
				"Our Website & eCommerce solution lets you build a professional website in days, manage online sales, and grow your digital presence. With WYSIWYG design tools, integrated payments, inventory sync, and seamless connections to platforms like Shopee and Lazada, you can create a smooth shopping experience that turns visitors into loyal customers.",
			logo: "../ecommerce1.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Finance & Accounting & Invoicing",
			description:
				"Finance & Accounting simplifies your financial operations with real-time reporting, automated invoicing, expense tracking, bank reconciliation, and tax management. Easily manage your journal entries, balance sheets, Spreadsheet (BI) and reports, giving you a clear, accurate view of your company’s financial health.",
			logo: "../accountant.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Supply Chain & Inventory & Manufacturing",
			description:
				"Supply Chain, Inventory, and Manufacturing apps automate RFQs, purchase orders, and reordering. Optimize procurement, manage vendor bills, and improve warehouse efficiency with PLM - product lifecycle management, quality control, reorder scheduling, and barcode systems. Boost efficiency, reduce waste, and ensure timely deliveries.",
			logo: "../supply-chain1.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Odoo ERP Services Apps",
			description:
				"There are over 70++ official apps, along with customizable options, allowing you to tailor them to your specific business needs — including LMS, KMS, Helpdesk, Forum, Survey, and more. Our goal is to streamline your operations and drive sustainable business growth.",
			logo: "../partnership.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: false,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Odoo ERP Training & Support",
			description:
				"We provide tailored Odoo training and support services to help your team confidently manage all implemented business modules. Our flexible support plans cover troubleshooting, updates, user assistance, and system optimization, ensuring smooth operations and continuous growth with Odoo.",
			logo: "../customer-support.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Odoo ERP Maintenance & Upgrades",
			description:
				"We provide Odoo maintenance and upgrades as an annually renewable service to keep your system secure, optimized, and up-to-date. Our team handles regular health checks, bug fixes, security updates, and smooth version upgrades, ensuring your Odoo environment remains reliable and ready to grow with your business.",
			logo: "../monitoring.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: false,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},


		{
			title: "IT Services & Cloud Solutions",
			description:
				"Our IT Services & Cloud Solutions streamline daily operations through cloud setup, configuration, and migration. We also implement DevOps pipelines to accelerate development and deployment. With competitive support rates, we deliver cost-effective solutions that scale with your business.",
			logo: "../cloudengineer.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: false,
			toExcludeInITServicePage: false,
			toExcludeInBIPage: true,
		},

		{
			title: "Cloud Setup & Migration",
			description:
				"Migration to platforms like AWS, Azure, AliCloud or private cloud—delivering secure, scalable infrastructure tailored to your needs.",
			logo: "../cloudmigration.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: false,
			toExcludeInBIPage: true,
		},

		{
			title: "Cloud Configuration & Optimization",
			description:
				"We fine-tune your cloud environment for performance, security, and cost-efficiency—so you only pay for what you truly need.",
			logo: "../cloudconfiguration.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: false,
			toExcludeInBIPage: true,
		},

		{
			title: "DevOps Pipeline Implementation",
			description:
				"Accelerate development with automated CI/CD pipelines, infrastructure as code, and integrated monitoring.",
			logo: "../devops.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Platform Management & Monitoring",
			description:
				"Real-time system monitoring and proactive management to minimize downtime and maintain operational health. A monthly performance report will be provided.",
			logo: "../cloudinfrastructure.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: false,
			toExcludeInBIPage: true,
		},

		{
			title: "Backup & Disaster Recovery",
			description:
				"Safeguard your critical data with secure, automated backups and rapid recovery plans designed around your risk profile.",
			logo: "../backup.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "IT Consulting & Strategy",
			description:
				"Get advice on digital transformation, cloud architecture, and infrastructure planning—aligned with your business goals.",
			logo: "../customer-support.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "Cost-Effective Support Plans",
			description:
				"Scalable support packages with transparent pricing and fast response times—because powerful IT should be accessible to every business.",
			logo: "../profit-margin.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: false,
			toExcludeInBIPage: true,
		},

		{
			title: "Business Intelligence & Analytics Solutions",
			description:
				"Empower your teams with intuitive, self-service analytics using leading open-source BI tools. We provide complete setup, best-practice consulting, and hands-on training to help your users explore data, build dashboards, and uncover insights to drive smarter business decisions.",
			logo: "../creative-idea.png",
			linkText: "contact us",
			link: "../contact",
			infoHide: "—Apache Superset, Metabase, and Redash",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},

		{
			title: "BI Services",
			description:
				"Beyond deployment, we offer training and tailored configuration services to equip your team with practical BI skills. Our sessions empower IT staff, and analysts to confidently build dashboards, explore data, and generate meaningful reports — for long-term success and self-reliance.",
			logo: "../customer-support.png",
			linkText: "contact us",
			link: "../contact",
			toExcludeInERPPage: true,
			toExcludeInHomePage: true,
			toExcludeInITServicePage: true,
			toExcludeInBIPage: true,
		},
	],
};


export default INFO;
